export const HOME = {
  heroPrimaryCta: "hero-primary-cta",
  heroSecondaryCta: "hero-secondary-cta",
  statCard: (id) => `stat-card-${id}`,
  bidangCard: (slug) => `bidang-card-${slug}`,
  beritaCard: (idx) => `berita-card-${idx}`,
  sipelikanCta: "sipelikan-cta",
};

export const NAV = {
  logo: "nav-logo",
  menuItem: (slug) => `nav-menu-${slug}`,
  adminLogin: "nav-admin-login",
  mobileToggle: "nav-mobile-toggle",
};

export const KONTAK = {
  formNama: "kontak-nama",
  formEmail: "kontak-email",
  formInstansi: "kontak-instansi",
  formSubject: "kontak-subject",
  formPesan: "kontak-pesan",
  formSubmit: "kontak-submit",
};

export const ADMIN = {
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  logout: "admin-logout",
  sidebarLink: (slug) => `admin-sidebar-${slug}`,
  addNew: (kind) => `admin-add-${kind}`,
  deleteBtn: (kind, id) => `admin-delete-${kind}-${id}`,
};
